import http from '@/http'
const URL = '/admin/rooms'

export const list = async (params) => {
  const list = (await http.get(URL + `/${params.room_id}/public-questions?include=user`, { params: params }))
  return list
}

export const find = async (id) => {
  let one = null
  if (id) {
    one = (await http.get(URL + `/${id}?include=user`))
  }
  return one
}

export const updateStatus = (payload) => http.put(URL + `/${payload.room_id}/public-questions/${payload.id}/status`, payload)

export const deletePublicQuestion = async (payload) => http.delete(URL + `/${payload.room_id}/public-questions/${payload.id}`)

export default {
  list,
  find,
  updateStatus,
  deletePublicQuestion
}
